module.exports = __webpack_public_path__ + "static/img/arcade.bb8f4b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partnerships/arcade.png
// module id = mnEo
// module chunks = 1